export default {"src":"/polygon/_next/static/media/fund_15.8c3ea6e2.svg","height":80,"width":231};